import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  AddExpenseMatchParams,
  addExpenseRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectReceiptAttachmentsListModels } from 'src/redux/selectors/data/receiptAttachments.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectPostingExpenseFromState = (state: RootState): boolean =>
  state.app.addExpense.postingExpense

const selectReceiptAttachmentIdsFromState = (state: RootState): string[] =>
  state.app.addExpense.receiptAttachmentIds

export const selectReceiptAttachmentModelsList = createSelector(
  [selectReceiptAttachmentIdsFromState, selectReceiptAttachmentsListModels],
  (ids, receiptAttachments) => ids.map((id) => receiptAttachments[id]),
)

export const selectUploadingAttachmentsFromState = (
  state: RootState,
): Record<string, string> => state.app.addExpense.uploadingAttachmentThumbnails

export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined => state.app.addExpense.errorDetailMap

export const selectTopLevelError = (state: RootState): string | undefined =>
  state.app.addExpense.topLevelError

export const selectExpenseReportIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<AddExpenseMatchParams>(
      location.pathname,
      addExpenseRouteProps,
    ) as match<AddExpenseMatchParams>
    return mtch?.params.id
  },
)
